import _ from "underscore";

import type { Selected } from "type_aliases";

export { toggleElement, toggleElementCascade } from "./toggle_element";
export { toggleAllElements } from "./toggle_all_elements";
export { updateFilterFromIdList } from "./update_filter_from_id_list";


export type StringIdFilter = {
  [id: string]: {
    id: string
    selected: Selected
    parentId: string
    childIds: string[]
  }
}

export type NumberIdFilter = {
  [id: number]: {
    id: number
    selected: Selected
    parentId: number
    childIds: number[]
  }
}

export const isFilter = (object: any): object is Filter => {
  return _(object).any((filter) => {
    return _.has(filter, "id")
      && _.has(filter, "selected")
      && _.has(filter, "parentId")
      && _.has(filter, "childIds");
  });
}

export type Filter = StringIdFilter | NumberIdFilter
